import {GridCellProps} from "@progress/kendo-react-grid";
import React, {useEffect} from "react";
import moment from "moment";

export const DateCell: React.VFC = (props: GridCellProps) => {
  return (<td>
    {moment(props.dataItem.EntryDate).year() > 1 && moment(props.dataItem.EntryDate).format('DD/MM/yyyy')}
    </td>);
}
